import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const TabPanel = (props) => {
  const { children, value, index, sx, ...other } = props;

  return (
    <Box
      id={`simple-tabpanel-${index}`}
      role="tabpanel"
      hidden={value !== index}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ ...sx, pt: 2 }}>{[children]}</Box>}
    </Box>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  sx: PropTypes.object,
  value: PropTypes.number.isRequired
};

export default TabPanel;
